import React from "react";
import { getAvatarInitials } from "../../utils";
import { Avatar } from "@common-ui/ui";

export const ProfileImage = ({
    data,
    height,
    width
}) => {
    const initials = data?.name || data?.screen_name;
    const image_url = data?.logo;
    if (image_url) {
        return (
            <img
                src={image_url}
                srcSet={image_url}
                alt={initials}
                loading="lazy"
                style={{ height: height, width: width, objectFit: "contain" }} />
        );
    }
    return <Avatar
        variant="square"
        alt={initials}
        src={getAvatarInitials(initials)}
        sx={{ height: height, width: width }}
    />
}

ProfileImage.defaultProps = {
    height: "150px",
    width: "150px"
}